<template>
  <div class="page-header navbar"><!--navbar-fixed-top-->
    <!-- BEGIN HEADER INNER -->
    <div class="page-header-inner container">
      <!-- BEGIN LOGO -->
      <div class="page-logo" style="padding-left:2px;">
        <router-link :to="{name: 'home'}">
          <img src="../assets/global/img/logo.png" alt="logo" class="logo-default"/>
          <!--../assets/layouts/layout/img/logo.png-->
        </router-link>
        <!--<div class="menu-toggler sidebar-toggler"> </div>-->
      </div>
      <!-- END LOGO -->
      <!-- BEGIN HEADER SEARCH BOX -->
      <!--<form class="search-form " onsubmit="return false;">
          <div class="input-group">
              <input type="text" class="form-control" placeholder="Search..." name="query">
              <span class="input-group-btn">
                  <a href="javascript:void(0);" class="btn submit">
                      <i class="icon-magnifier"></i>
                  </a>
              </span>
          </div>
      </form>-->
      <!-- END HEADER SEARCH BOX -->
      <!-- BEGIN RESPONSIVE MENU TOGGLER -->
      <a href="javascript:;" class="menu-toggler responsive-toggler" data-toggle="collapse"
         data-target=".navbar-collapse"> </a>
      <!-- END RESPONSIVE MENU TOGGLER -->
      <!-- BEGIN TOP NAVIGATION MENU -->
      <div class="top-menu">
        <ul class="nav navbar-nav pull-right">
          <!--<li class="dropdown dropdown-extended dropdown-notification" id="header_notification_bar">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-others="true" v-dropdown>
                  <i class="icon-bell"></i>
                  <span class="badge badge-default"> 0 </span>
              </a>
              <ul class="dropdown-menu">
                  <li class="external">
                      <h3><span class="bold">12 </span> 通知</h3>
                      <a href="#"></a>
                  </li>
                  <li>
                      <ul class="dropdown-menu-list scroller" style="height: 250px;" data-handle-color="#637283">
                          <li>
                              <a href="javascript:;">
                                  <span class="time">just now</span>
                                  <span class="details">
                                      <span class="label label-sm label-icon label-success">
                                          <i class="fa fa-plus"></i>
                                      </span> New user registered. </span>
                              </a>
                          </li>
                          <li>
                              <a href="javascript:;">
                                  <span class="time">3 mins</span>
                                  <span class="details">
                                      <span class="label label-sm label-icon label-danger">
                                          <i class="fa fa-bolt"></i>
                                      </span> Server #12 overloaded. </span>
                              </a>
                          </li>
                          <li>
                              <a href="javascript:;">
                                  <span class="time">10 mins</span>
                                  <span class="details">
                                      <span class="label label-sm label-icon label-warning">
                                          <i class="fa fa-bell-o"></i>
                                      </span> Server #2 not responding. </span>
                              </a>
                          </li>
                          <li>
                              <a href="javascript:;">
                                  <span class="time">14 hrs</span>
                                  <span class="details">
                                      <span class="label label-sm label-icon label-info">
                                          <i class="fa fa-bullhorn"></i>
                                      </span> Application error. </span>
                              </a>
                          </li>
                          <li>
                              <a href="javascript:;">
                                  <span class="time">2 days</span>
                                  <span class="details">
                                      <span class="label label-sm label-icon label-danger">
                                          <i class="fa fa-bolt"></i>
                                      </span> Database overloaded 68%. </span>
                              </a>
                          </li>
                          <li>
                              <a href="javascript:;">
                                  <span class="time">3 days</span>
                                  <span class="details">
                                      <span class="label label-sm label-icon label-danger">
                                          <i class="fa fa-bolt"></i>
                                      </span> A user IP blocked. </span>
                              </a>
                          </li>
                          <li>
                              <a href="javascript:;">
                                  <span class="time">4 days</span>
                                  <span class="details">
                                      <span class="label label-sm label-icon label-warning">
                                          <i class="fa fa-bell-o"></i>
                                      </span> Storage Server #4 not responding dfdfdfd. </span>
                              </a>
                          </li>
                          <li>
                              <a href="javascript:;">
                                  <span class="time">5 days</span>
                                  <span class="details">
                                      <span class="label label-sm label-icon label-info">
                                          <i class="fa fa-bullhorn"></i>
                                      </span> System Error. </span>
                              </a>
                          </li>
                          <li>
                              <a href="javascript:;">
                                  <span class="time">9 days</span>
                                  <span class="details">
                                      <span class="label label-sm label-icon label-danger">
                                          <i class="fa fa-bolt"></i>
                                      </span> Storage server failed. </span>
                              </a>
                          </li>
                      </ul>
                  </li>
              </ul>
          </li>-->
          <li class="dropdown dropdown-user">
            <a href="javascript:;" class="dropdown-toggle" v-dropdown>
              <img v-if="loginUser.headImg" class="img-circle" style="width:28px;height:28px;"
                   :src="thumb(loginUser.headImg, 28, 28)"/>
              <img v-else class="img-circle" src="../assets/layouts/layout/img/avatar3_small.jpg"/>
              <span class="username username-hide-on-mobile"> {{loginUser.nickName || loginUser.name}} </span>
              <i class="fa fa-angle-down"></i>
            </a>
            <ul class="dropdown-menu dropdown-menu-default">
              <li>
                <router-link :to="{name: 'profile'}"
                            tag="a"
                            active-class="open active"
                            class="nav-item">
                    <i class="icon-user"></i> 我的信息
                </router-link>
              </li>
              <li>
                <a href="javascript:void(0);" @click="logout()">
                  <i class="icon-key"></i> 退出 </a>
              </li>
            </ul>
          </li>
          <!-- END USER LOGIN DROPDOWN -->
        </ul>
      </div>
      <!-- END TOP NAVIGATION MENU -->
    </div>
    <!-- END HEADER INNER -->
  </div>
</template>


<script>

  import $ from 'jquery'
  import '../assets/global/plugins/select2/js/select2.full.min.js'
  import '../assets/global/plugins/backstretch/jquery.backstretch.js'
  import methods from '../methods'

  import { mapState, mapActions } from 'vuex'

  export default {
    data () {
      return {}
    },
    created () {},
    mounted () {},
    computed: mapState([
      'loginUser'
    ]),
    methods: {
      ...mapActions([
        'showAlert',
        'showLoading',
        'hideLoading',
        'toast'
      ]),
      ...methods,
      logout () {
        let self = this

        this.$api.logout().finally(function () {
          self.$router.push({
            name: 'login'
          })
          //window.location = '/web-mgr'
        })
      }
    }
  }

</script>
